/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ApiAlertType {
    MONITORING = 'MONITORING',
    SCREENING = 'SCREENING',
    BRIDGE = 'BRIDGE',
    MANUAL = 'MANUAL'
}


export function instanceOfApiAlertType(value: any): boolean {
    for (const key in ApiAlertType) {
        if (Object.prototype.hasOwnProperty.call(ApiAlertType, key)) {
            if (ApiAlertType[key as keyof typeof ApiAlertType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ApiAlertTypeFromJSON(json: any): ApiAlertType {
    return ApiAlertTypeFromJSONTyped(json, false);
}

export function ApiAlertTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiAlertType {
    return json as ApiAlertType;
}

export function ApiAlertTypeToJSON(value?: ApiAlertType | null): any {
    return value as any;
}

export function ApiAlertTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): ApiAlertType {
    return value as ApiAlertType;
}

